import { TextField, MenuItem, Tooltip, Typography } from '@mui/material'
import { GroupOption } from '@/types/metrics'

type GroupedBySelectorProps = {
  groupedBy: GroupOption
  onChange: (groupedBy: GroupOption) => void
  options?: GroupOption[]
  variant?: 'filled' | 'outlined'
}

export default function GroupedBySelector({
  groupedBy,
  onChange,
  options,
  variant = 'outlined',
}: GroupedBySelectorProps) {
  function handleChange(event: React.ChangeEvent<{ value: unknown }>) {
    onChange(event.target.value as GroupOption)
  }
  const updatedOptions = options || ['hour', 'day', 'month', 'year']
  return (
    <TextField
      select
      label="Group By"
      value={groupedBy}
      onChange={handleChange}
      variant={variant}
      sx={{
        minWidth: 100,
      }}
    >
      {updatedOptions.map((option) => (
        <MenuItem key={option} value={option}>
          <Tooltip
            title={
              option === 'hour' ? 'Only accepts a range of up to 7 days' : ''
            }
            enterDelay={500}
            disableInteractive
          >
            <Typography sx={{ width: '100%' }}>
              {option.charAt(0).toUpperCase().concat(option.slice(1))}
            </Typography>
          </Tooltip>
        </MenuItem>
      ))}
    </TextField>
  )
}
